
import { useCallback } from 'react'

// hooks
import useYam from '../bakery/useYam'

// sushi
import { 
  transferErc721
} from '../../sushi/utils'
import { userNFTContract } from '../../userType/userNFTContract'

const useTransfer = (type?: string) => {
  const sushi = useYam()
  let sushiContract = userNFTContract(sushi, type)

  const handleTransfer = useCallback(async (tokenId: string, account, transferAddress: any) => {
    if (tokenId && account && transferAddress) {
      try {
        const pet = await transferErc721(sushiContract, account, transferAddress, tokenId)
        return pet
      } catch (e) {
        console.log('useIdoPet', e)
        return false
      }
    } else {
      return false
    }
  }, [sushiContract])

  return {onTransfer: handleTransfer}
}

export default useTransfer
